import React from "react";
import { Helmet } from "react-helmet";
import Layout from "../components/Layoutthree";
import { Form } from "../components/form";
import { SEO } from "../components/seo";

const JobApplyForm = () => {
  return (
    <Layout>
      <Helmet title="Job Apply" />
      <section className="top-banner-overlay">
        <div className="title-image-job">
          <div className="overlay">
            <div className="container">
              {/* <h2 className="mb-3">{currentJob.name}</h2>
              <div>
                <span>{currentJob.location}</span>
              </div> */}
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="container py-5">
          <div className="row">
            <div className="col-12 col-md-8 mb-5">
              <div className="job-card-form pe-md-5">
                <h3>Apply for the job</h3>
                <Form
                  name={true}
                  email={true}
                  contact={true}
                  message={true}
                  cv={true}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default JobApplyForm;

export const Head = () => (
  <SEO
    title="Deerhold: Apply for the Job"
    description=""
    keywords="Apply for Jobs, Career in Tech, Work, Employment, Internship in Nepal, Job Openings, Deerwalk, Tech Industry, IT job"
    pathname="/job-apply-form"
    image="/DeerholdOG.jpg"
  />
);
